// CagriBellGiris.js
// Konum: src/CagriBellGiris.js — Route: /

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
} from 'firebase/auth';
import { auth } from './firebaseClient';
import { authFetch } from './authFetch';

// Geliştirme için localhost, canlıya alırken kendi backend adresinle değiştir
// (örnek: https://cagribell.3amenu.com/api ya da doğrudan sunucu IP:3002)
const BACKEND = process.env.REACT_APP_API_URL;

export default function CagriBellGiris() {
  const navigate = useNavigate();
  const [mod, setMod] = useState('giris');
  const [email, setEmail] = useState('');
  const [sifre, setSifre] = useState('');
  const [isletmeAdi, setIsletmeAdi] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);
  const [hata, setHata] = useState('');

  const girisYap = async () => {
    setYukleniyor(true);
    setHata('');
    try {
      await signInWithEmailAndPassword(auth, email, sifre);
      navigate('/admin');
    } catch (err) {
      setHata('E-posta veya şifre hatalı.');
    }
    setYukleniyor(false);
  };

  const kayitOl = async () => {
    if (!isletmeAdi.trim()) {
      setHata('İşletme adını girin.');
      return;
    }
    setYukleniyor(true);
    setHata('');
    try {
      const cred = await createUserWithEmailAndPassword(auth, email, sifre);
      await authFetch(`${BACKEND}/call-waiter/business/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ownerUid: cred.user.uid, businessName: isletmeAdi.trim() }),
      });
      navigate('/admin');
    } catch (err) {
      setHata('Kayıt sırasında hata oluştu. E-posta zaten kullanılıyor olabilir.');
    }
    setYukleniyor(false);
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="text-5xl mb-3">🔔</div>
          <h1 className="text-white text-2xl font-bold">Çağrı Bell</h1>
          <p className="text-slate-400 text-sm mt-1">Garson çağırma sistemi</p>
        </div>

        <div className="bg-slate-800 rounded-2xl p-6">
          <div className="flex gap-2 mb-6 bg-slate-900 rounded-lg p-1">
            <button
              onClick={() => setMod('giris')}
              className={`flex-1 py-2 rounded-md text-sm font-semibold transition-colors ${
                mod === 'giris' ? 'bg-orange-500 text-white' : 'text-slate-400'
              }`}
            >
              Giriş Yap
            </button>
            <button
              onClick={() => setMod('kayit')}
              className={`flex-1 py-2 rounded-md text-sm font-semibold transition-colors ${
                mod === 'kayit' ? 'bg-orange-500 text-white' : 'text-slate-400'
              }`}
            >
              Kayıt Ol
            </button>
          </div>

          {mod === 'kayit' && (
            <input
              value={isletmeAdi}
              onChange={(e) => setIsletmeAdi(e.target.value)}
              placeholder="İşletme adı"
              className="w-full bg-slate-900 border border-slate-700 rounded-lg px-4 py-3 text-white text-sm mb-3 focus:outline-none focus:border-orange-400"
            />
          )}
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="E-posta"
            type="email"
            className="w-full bg-slate-900 border border-slate-700 rounded-lg px-4 py-3 text-white text-sm mb-3 focus:outline-none focus:border-orange-400"
          />
          <input
            value={sifre}
            onChange={(e) => setSifre(e.target.value)}
            placeholder="Şifre"
            type="password"
            className="w-full bg-slate-900 border border-slate-700 rounded-lg px-4 py-3 text-white text-sm mb-4 focus:outline-none focus:border-orange-400"
          />

          {hata && <p className="text-red-400 text-xs mb-3">{hata}</p>}

          <button
            onClick={mod === 'giris' ? girisYap : kayitOl}
            disabled={yukleniyor}
            className="w-full bg-orange-500 text-white py-3 rounded-lg font-semibold text-sm disabled:opacity-60"
          >
            {yukleniyor ? '...' : mod === 'giris' ? 'Giriş Yap' : 'Kayıt Ol'}
          </button>
        </div>
      </div>
    </div>
  );
}